import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap/components/modal/modal.component';
import { LoaderEvent, SetAllMemberCheck } from './../../shared/message.event';
import { PrimecalendarService } from './../primecalendar.service';
import { MemberService } from '../../member/member.service';
import { CONSTANT_VALUES } from '../../constants/constant-values';
import { AppService } from '../../app.service';
import { Invoice } from './../Invoice';
import { CONSTANT_MESSAGES } from '../../constants/constants-messages';
import { UtilityFunctions } from '../../shared/utility-functions';

import * as moment from 'moment';
import * as _ from 'lodash';

@Component({
  selector: 'app-walkin-booking',
  templateUrl: './walkin-booking.component.html',
  styleUrls: ['./walkin-booking.component.css'],
  providers: [LoaderEvent, PrimecalendarService, MemberService, AppService, SetAllMemberCheck],
  exportAs: 'walkinBookingPopUpObj'
})
export class WalkinBookingComponent implements OnInit {
  protected confirmation = 'Confirmation';

  @ViewChild('childModal') childModal: ModalDirective;
  @ViewChild('errorPopUpObj') errorPopUpObj: any;


  @Input() message = '';
  @Input() popupTitle: string;
  @Input() deleteMessage: string;
  @Input() selectedUnit: string;
  @Input() selectedActivity: any;
  @Input() startTime: string;
  @Input() endTime: string;
  @Input() facility: any;
  @Input() selectedStartDate: Date;

  @Output() callRefreshList = new EventEmitter<any>();

  // strings / constants
  protected stringConstants = CONSTANT_MESSAGES;
  private memberType = CONSTANT_VALUES.MEMBER_TYPE;

  // slot list used to align start times
  private timingSlots: Array<{ hour: number; minute: number }> = [];

  // UI strings
  private eventdate: string;
  private eventStartTime: string;
  private eventEndTime: string;

  private errMessage = '';

  // booking form model
  private bookingObj: any = {
    emailId: '',
    contactNumber: '',
    firstName: '',
    membershipId: '',
    userId: '',
    attendees: '1',
    hours: '',
    startTime_hours: '',
    startTime_minutes: '',
    startTime: '',
    endTime: '',
    type: '',
    lastName: '',
    isForcedBooking: false,
    countryCode: '',
    slots: '1',
    addressLine1: '',
    addressLine2: '',
    note: '',
    groupNames: '',
    groups: [],
    bookingVendorNote: ''
  };

  // field-level validators
  private validate: any = {
    emailId: '',
    contactNumber: '',
    firstName: '',
    membershipId: '',
    attendees: '',
    hour: '',
    flag: false,
    startTime_hours: '',
    startTime_minutes: '',
    startTime: '',
    endTime: '',
    type: '',
    lastName: '',
    isForcedBooking: false,
    countryCode: '',
    slots: '',
    memberIdOrFirstName: '',
    repeatCount: ''
  };

  // UI state
  private isContactDisable = true;
  private memberList: any[] = [];
  private isEmailIdDisable = true;
  protected popUpMessage = '';

  private vendor: any;
  private showHour = false;
  private _appService: AppService;
  private timezoneOffset = 0;

  protected unitName: string;
  public facilityName: string;

  private showAddMemberFields = false;
  private showAddMemberMessage = false;
  private isShowAllowForceBooking = false;
  private isShowContinueBookingMessage = false;
  private continueBookingMessage = '';
  private isShowCanBeForceBookedMessage = false;
  private isDayBookingError = false;
  private dayBookingErrorMessage: string;

  private countryCodes: any[] = [];
  private selectedBookingDate: any;
  private bookingDate: Date = new Date();

  private minDate: Date;
  private endMinDate: Date;
  private startMaxDate: any;
  private noOfPeopleErrorMsg = '';

  private hours_value = CONSTANT_VALUES.HOUR_VALUES;
  private minutes_value = CONSTANT_VALUES.MINUTE_VALUES;
  private ActivityStartTimeHoursList: string[] = [];

  private disableDecreaseIcon = true;
  private nocursor = '';
  private nocursorplus = '';
  private disableIncreaseIcon = false;

  private disableDecreaseIconOfSlots = true;
  private noCursorSlots = '';

  private isOpenNextMonthBooking: boolean;
  private isShowWithinBookingperiodErrorMsg: boolean;
  private withinBookingperiodErrorMsg: string;

  private utilityFunctions = new UtilityFunctions();

  private disableIncreaseIconSlot = false;
  private nocursorplusSlot = '';

  public bookingStartLockOn = '';
  private blockPrev = false;
  private blockNext = false;

  protected bookingPopupMessage = '';
  private bookButtonText = '';
  protected memberAddedSuccesfullyMsg = '';
  private userId = '';
  private membershipIdErr = '';
  private memberIdOrFirstName = '';
  private isopen1 = false;
  private repeatCount = 0;

  private requestForRepeat: any;
  private statusChecked = false;
  private statusOFBookings: any[] = [];
  private checkAvailability = false;
  private showBook = true;
  private memberAddedMessage = '';
  private isShowAvailabilityStatus = false;
  private monthWiseBlock: any[] = [];
  private allSlotsUnavailable = true;
  protected bookingConfirmation = false;

  public isEventCategory = false;
  public isGroupClassCategory = false;

  private confirmationBookingResult: any;
  protected paymentDoneMessage = '';

  public eventDateUpdateRestrictedMsg = CONSTANT_MESSAGES.EVENT_DATE_UPDATE_RESTRICTED_DURING_BOOKING;

  // used by template bindings
  public viewStatus = false;
  public errorMessage: any = '';

  constructor(
    private loaderEvent: LoaderEvent,
    private calendarService: PrimecalendarService,
    private _memberService: MemberService,
    private appService: AppService,
    private setAllMemberCheck: SetAllMemberCheck
  ) {
    this._appService = appService;
    const vendorRaw = localStorage.getItem('vendor');
    if (vendorRaw) {
      try {
        this.vendor = JSON.parse(atob(vendorRaw));
        this.timezoneOffset = (this.vendor && typeof this.vendor.timezoneOffset !== 'undefined')
          ? (this.vendor.timezoneOffset * -1)
          : 0;
      } catch (e) {
        this.vendor = null;
        this.timezoneOffset = 0;
      }
    }
  }

  /** Group class: set start/end from facility timings and open modal. */
  private setGroupClassTimingsFromFacility(): void {
    try {
      const open = (this.selectedActivity && this.selectedActivity.timings && this.selectedActivity.timings.openTime) ? this.selectedActivity.timings.openTime : '00:00';
      const close = (this.selectedActivity && this.selectedActivity.timings && this.selectedActivity.timings.closeTime) ? this.selectedActivity.timings.closeTime : '23:59';

      const [ohS, omS] = open.split(':');
      const [chS, cmS] = close.split(':');

      const oh = parseInt(ohS, 10) || 0;
      const om = parseInt(omS, 10) || 0;
      const ch = parseInt(chS, 10) || 0;
      const cm = parseInt(cmS, 10) || 0;

      this.bookingObj.startTime_hours = ('0' + oh).slice(-2);
      this.bookingObj.startTime_minutes = ('0' + om).slice(-2);

      const endDisplay = (ch === 24 && cm === 0)
        ? '24:00'
        : (('0' + ch).slice(-2) + ':' + ('0' + cm).slice(-2));

      this.bookingObj.endTime = endDisplay;
      this.bookingStartLockOn = this.bookingObj.startTime_hours + ':' + this.bookingObj.startTime_minutes;

      this.blockPrev = false;
      this.blockNext = false;

      if (this.selectedActivity && this.selectedActivity.isSlotsLocked) {
        this.calculateEndTimeFromLockSlot();
      }

      // clear validation errors on these fields
      this.validate.startTime_hours = '';
      this.validate.startTime_minutes = '';
      this.validate.endTime = '';

      // show modal
      this.utilityFunctions.setBackGroundBlack();
      if (this.childModal && this.childModal.config) { this.childModal.config.backdrop = false; }
      if (this.childModal) { this.childModal.show(); }
    } catch (e) {
      console.log(e);
    }
  }

  public showChildModal(selectedUnit?: string): void {
    console.log('selectedUnit', selectedUnit);
    this.testCategory();

    this.facilityName =
    (this.selectedActivity && this.selectedActivity.name) ||
    (this.facility && this.facility.name) ||
    '';

    const unitFromActivity =
    (this.selectedActivity &&
     Array.isArray(this.selectedActivity.unitNames) &&
     this.selectedActivity.unitNames.length > 0)
      ? this.selectedActivity.unitNames[0]
      : '';

  this.unitName = (selectedUnit && selectedUnit.trim()) ||
                  (this.selectedUnit && this.selectedUnit.trim()) ||
                  unitFromActivity ||
                  '';

    const category = (this.selectedActivity && this.selectedActivity.category
      ? this.selectedActivity.category : '').toLowerCase().trim();

    this.isEventCategory = (category === 'event' || category === 'events');
    this.isGroupClassCategory = (category === 'group classes' || category === 'group class');

    // Set date: Events & Group Classes pick from selectedActivity.date
    if (this.isEventCategory || this.isGroupClassCategory) {
      if (this.selectedActivity && this.selectedActivity.date) {
        this.bookingDate = moment(this.selectedActivity.date, 'YYYY-MM-DD HH:mm:ss.SSS').toDate();
      } else {
        this.bookingDate = this.selectedStartDate || new Date();
      }
    } else {
      this.bookingDate = this.selectedStartDate || new Date();
    }

    // Reset UI state
    this.memberIdOrFirstName = '';
    this.isEmailIdDisable = true;

    // Reset forms
    this.bookingObj = {
      emailId: '',
      contactNumber: '',
      firstName: '',
      membershipId: '',
      userId: '',
      attendees: '1',
      hours: '',
      startTime_hours: '',
      startTime_minutes: '',
      startTime: '',
      endTime: '',
      type: '',
      lastName: '',
      isForcedBooking: false,
      countryCode: '+65',
      slots: '1',
      addressLine1: '',
      addressLine2: '',
      note: '',
      groupNames: '',
      groups: [],
      bookingVendorNote: ''
    };

    this.validate = {
      emailId: '',
      contactNumber: '',
      firstName: '',
      membershipId: '',
      attendees: '',
      hour: '',
      flag: false,
      startTime_hours: '',
      startTime_minutes: '',
      startTime: '',
      endTime: '',
      type: '',
      lastName: '',
      isForcedBooking: false,
      countryCode: '',
      slots: '',
      memberIdOrFirstName: '',
      repeatCount: ''
    };

    this.errMessage = '';
    this.isShowWithinBookingperiodErrorMsg = false;
    this.withinBookingperiodErrorMsg = '';

    const timeZoneDate = moment().utcOffset(this.timezoneOffset);
    this.endMinDate = new Date(timeZoneDate.year(), timeZoneDate.month(), timeZoneDate.date(), timeZoneDate.hour(), timeZoneDate.minutes());
    this.minDate = new Date(timeZoneDate.year(), timeZoneDate.month(), timeZoneDate.date(), timeZoneDate.hour(), timeZoneDate.minutes());

    this.bookingObj.attendees = '1';
    this.bookButtonText = CONSTANT_MESSAGES.BOOK_BUTTON_TEXT;
    this.isShowCanBeForceBookedMessage = false;
    this.ActivityStartTimeHoursList = [];
    this.bookingStartLockOn = '';
    this.memberAddedSuccesfullyMsg = '';
    this.isopen1 = false;
    this.continueBookingMessage = '';
    this.statusOFBookings = [];
    this.memberAddedMessage = '';
    this.isShowAvailabilityStatus = false;
    this.monthWiseBlock = [];
    this.confirmationBookingResult = undefined;
    this.paymentDoneMessage = '';

    // repeat count: Group Classes => facility "no of times"; else weekly default
    if (this.isGroupClassCategory) {
      let rcSrc: any = (this.selectedActivity && (this.selectedActivity.noOfTimes || this.selectedActivity.noofTimes));
      this.repeatCount = (parseInt(rcSrc, 10) > 0) ? parseInt(rcSrc, 10) : 1;
    } else {
      this.repeatCount = (this.selectedActivity && this.selectedActivity.isWeeklyRepeatBooking) ? 1 : 0;
    }

    // Check availability visibility/flow
    if (this.isGroupClassCategory) {
      this.checkAvailability = false;
      this.showBook = false;              // enable final book button immediately
      this.allSlotsUnavailable = false;   // allow button enabled
    } else {
      this.checkAvailability = !!(this.selectedActivity && this.selectedActivity.isWeeklyRepeatBooking);
      this.showBook = !!(this.selectedActivity && this.selectedActivity.isWeeklyRepeatBooking);
      this.allSlotsUnavailable = true;
    }

    // init time lists and modal
    this.makeListForTime();
    if (this.isGroupClassCategory) {
      this.setGroupClassTimingsFromFacility();   // uses facility timings and shows modal
    } else {
      this.displayNewBookingPopup(selectedUnit); // existing behavior
    }
    this.getMaxDateIfMonthRule();

    // ensure Group Class defaults stick
    this.applyGroupClassDefaults();
  }

  public hideChildModal(): void {
    this.utilityFunctions.removeBackGroundBlack();
    if (this.childModal) { this.childModal.hide(); }
  }

  ngOnInit() {
    this.appService.getAppVersion().then((result: any) => {
      this.countryCodes = (result && result.countryCodes) ? result.countryCodes : [];
    });
  }

  makeListForTime() {
    if (!this.selectedActivity) { this.ActivityStartTimeHoursList = []; return; }
    const lists = this.utilityFunctions.makeListForTime(this.selectedActivity, false);
    this.ActivityStartTimeHoursList = lists && lists[0] ? lists[0] : [];
  }

  getMaxDateIfMonthRule() {
    if (!this.selectedActivity) { this.startMaxDate = ''; this.isShowWithinBookingperiodErrorMsg = false; return; }

    this.isOpenNextMonthBooking = !!this.selectedActivity.isOpenNextMonthBooking;
    if (this.isOpenNextMonthBooking) {
      const selectedDate = moment(this.bookingDate).utcOffset(this.timezoneOffset);
      const response = this.utilityFunctions.checkFOrBookingPeriod(this.isOpenNextMonthBooking, selectedDate);
      const timeZoneDate = moment(response.endOfBookingPeriod).utcOffset(this.timezoneOffset);
      this.startMaxDate = new Date(timeZoneDate.year(), timeZoneDate.month(), timeZoneDate.date(), timeZoneDate.hour(), timeZoneDate.minutes());
      if (!response.isFollowingInBookingPeriod) {
        this.withinBookingperiodErrorMsg = CONSTANT_MESSAGES.BOOKING_OPEN_TILL_NEXT_MONTH +
          response.endOfBookingPeriod.format('MMMM Do YYYY') + CONSTANT_MESSAGES.BOOKING_OPEN_TILL_NEXT_MONTH_CONT;
        this.isShowWithinBookingperiodErrorMsg = true;
      } else {
        this.isShowWithinBookingperiodErrorMsg = false;
      }
    } else {
      this.startMaxDate = '';
      this.isShowWithinBookingperiodErrorMsg = false;
    }
  }

  /** If Group Class, set start/end times and repeat defaults. */
  private applyGroupClassDefaults(): void {
    if (!this.isGroupClassCategory) { return; }

    // timings -> start/end
    let timings: any = (this.selectedActivity && this.selectedActivity.timings) ? this.selectedActivity.timings : null;

    if (timings && timings.openTime && timings.closeTime) {
      const openParts = (timings.openTime + '').split(':');
      const closeParts = (timings.closeTime + '').split(':');
      const sh = parseInt(openParts[0], 10) || 0;
      const sm = parseInt(openParts[1], 10) || 0;
      const eh = parseInt(closeParts[0], 10) || 0;
      const em = parseInt(closeParts[1], 10) || 0;

      this.bookingObj.startTime_hours = ('0' + sh).slice(-2);
      this.bookingObj.startTime_minutes = ('0' + sm).slice(-2);
      this.bookingStartLockOn = this.bookingObj.startTime_hours + ':' + this.bookingObj.startTime_minutes;

      const endStr = (('0' + eh).slice(-2) + ':' + ('0' + em).slice(-2));
      this.bookingObj.startTime = this.bookingStartLockOn;
      this.bookingObj.endTime = (endStr === '23:59') ? '24:00' : endStr;

      this.validate.startTime_hours = '';
      this.validate.startTime_minutes = '';
      this.validate.startTime = '';
      this.validate.endTime = '';
      this.errMessage = '';
    }

    // repeat count from facility
    // let attendeesFromFacility: any = 1;
    // if (this.selectedActivity) {
    //   attendeesFromFacility = (typeof this.selectedActivity.noofTimes !== 'undefined' && this.selectedActivity.noofTimes !== null)
    //     ? this.selectedActivity.noofTimes
    //     : (typeof this.selectedActivity.noOfTimes !== 'undefined' && this.selectedActivity.noOfTimes !== null)
    //       ? this.selectedActivity.noOfTimes
    //       : 1;
    // }
    // this.bookingObj.attendees = String(attendeesFromFacility);
    this.validate.attendees = '';
    this.disableIncreaseIcon = false;
    this.disableDecreaseIcon = parseInt(this.bookingObj.attendees, 10) <= 1;
    this.nocursor = this.disableDecreaseIcon ? 'no-cursor' : '';
  }

  displayNewBookingPopup(selectedUnit?: string) {
        console.log('this.eventdate', selectedUnit);

    const unit = selectedUnit ? selectedUnit : '';
    if (!this.bookingDate) { this.bookingDate = this.selectedStartDate || new Date(); }
    const timeZoneSelectedDate = moment(this.bookingDate).utcOffset(this.timezoneOffset);
    this.eventdate = timeZoneSelectedDate.format('LL');
    this.eventStartTime = this.startTime;
    this.eventEndTime = this.endTime;
    this.facilityName = this.selectedActivity ? this.selectedActivity.name : '';
    console.log('this.selectedActivity', this.selectedActivity);

    this.unitName = unit ? unit : this.selectedUnit;
    this.isShowAllowForceBooking = !!(this.selectedActivity && this.selectedActivity.isAllowForceBooking);

    this.showAddMemberFields = false;
    this.showAddMemberMessage = false;
    this.isContactDisable = true;
    this.isEmailIdDisable = true;

    if (this.childModal && this.childModal.config) {
      this.childModal.config.backdrop = false;
    }

    this.disableDecreaseIcon = true;
    this.disableDecreaseIconOfSlots = true;
    this.disableIncreaseIcon = false;
    if (this.disableDecreaseIcon) { this.nocursor = 'no-cursor'; }
    if (this.disableDecreaseIconOfSlots) { this.noCursorSlots = 'no-cursor'; }
    this.nocursorplus = '';

    if (this.isGroupClassCategory) {
      // already handled by setGroupClassTimingsFromFacility
      this.utilityFunctions.setBackGroundBlack();
      if (this.childModal) { this.childModal.show(); }
      return;
    }

    // normal path
    this.fillActivitySlots();
    this.getActivitySlot();
    this.prepopulateValues();
    this.calculateBookingSlot();
    this.utilityFunctions.setBackGroundBlack();
    if (this.childModal) { this.childModal.show(); }
  }

  /** Helpers for slot grid / alignment **/
  private getSlotDuration(): number {
    let raw = 0;
    if (this.selectedActivity && typeof this.selectedActivity.slotDuration !== 'undefined') {
      raw = parseInt(String(this.selectedActivity.slotDuration), 10);
    }
    return isFinite(raw as any) && raw > 0 ? raw : CONSTANT_VALUES.AMENETIES_SLOT;
  }

  private isAlignedToSlot(h: number, m: number): boolean {
    if (!this.timingSlots || !this.timingSlots.length) return true;
    return this.timingSlots.some((s) => s.hour === h && s.minute === m);
  }

  private clampToSlot(h: number, m: number): { h: number; m: number } {
    if (!this.timingSlots || !this.timingSlots.length) return { h, m };
    const target = h * 60 + m;
    let best = this.timingSlots[0];
    let bestVal = best.hour * 60 + best.minute;
    for (let i = 0; i < this.timingSlots.length; i++) {
      const s = this.timingSlots[i];
      const val = s.hour * 60 + s.minute;
      if (val <= target && val >= bestVal) { best = s; bestVal = val; }
    }
    return { h: best.hour, m: best.minute };
  }

  private alignStartToSlot(): void {
    const sh = parseInt(this.bookingObj.startTime_hours || '0', 10);
    const sm = parseInt(this.bookingObj.startTime_minutes || '0', 10);
    if (!this.isAlignedToSlot(sh, sm)) {
      const snapped = this.clampToSlot(sh, sm);
      this.bookingObj.startTime_hours = ('0' + snapped.h).slice(-2);
      this.bookingObj.startTime_minutes = ('0' + snapped.m).slice(-2);
    }
    this.bookingStartLockOn = this.bookingObj.startTime_hours + ':' + this.bookingObj.startTime_minutes;
  }

  /** Build slot grid for the selected day. */
  private buildSlotsForDay(): moment.Moment[] {
    if (!(this.selectedActivity && this.selectedActivity.timings)) {
      return [];
    }
    const openStr = this.selectedActivity.timings.openTime || '00:00';
    const closeStr = this.selectedActivity.timings.closeTime || '23:59';
    const [sH, sM] = openStr.split(':');
    const [eH, eM] = closeStr.split(':');
    const startHour = parseInt(sH, 10) || 0;
    const startMinute = parseInt(sM, 10) || 0;
    const endHour = parseInt(eH, 10) || 0;
    const endMinute = parseInt(eM, 10) || 0;
    const slot = this.getSlotDuration();

    const base = moment(this.bookingDate || new Date()).utcOffset(this.timezoneOffset, true);
    const start = base.clone().set({ hour: startHour, minute: startMinute, second: 0, millisecond: 0 });
    const end = (endHour === 24 && endMinute === 0)
      ? base.clone().add(1, 'day').startOf('day')
      : base.clone().set({ hour: endHour, minute: endMinute, second: 0, millisecond: 0 });

    const out: moment.Moment[] = [];
    for (let t = start.clone(); t.isBefore(end); t.add(slot, 'minutes')) {
      out.push(t.clone());
    }
    return out;
  }

  fillActivitySlots(): void {
    this.timingSlots.length = 0;
    if (!this.selectedActivity || !this.selectedActivity.timings) return;

    const open = (this.selectedActivity.timings.openTime || '00:00').split(':');
    const close = (this.selectedActivity.timings.closeTime || '23:59').split(':');

    const startHour = parseInt(open[0], 10) || 0;
    const startMinute = parseInt(open[1], 10) || 0;
    const endHour = parseInt(close[0], 10) || 0;
    const endMinute = parseInt(close[1], 10) || 0;

    const slotInMinutesRaw = parseInt(String(this.selectedActivity.slotDuration), 10);
    const slotInMinutes = (isFinite(slotInMinutesRaw as any) && slotInMinutesRaw > 0)
      ? slotInMinutesRaw
      : CONSTANT_VALUES.AMENETIES_SLOT;

    const base = moment(this.bookingDate || new Date()).utcOffset(this.timezoneOffset, true);
    const start = base.clone().set({ hour: startHour, minute: startMinute, second: 0, millisecond: 0 });
    const end = (endHour === 24 && endMinute === 0)
      ? base.clone().add(1, 'day').startOf('day')
      : base.clone().set({ hour: endHour, minute: endMinute, second: 0, millisecond: 0 });

    if (slotInMinutes === 0) {
      if (start.isBefore(end)) {
        this.timingSlots.push({ hour: start.hour(), minute: start.minute() });
      }
      return;
    }

    const seen: { [k: string]: boolean } = {};
    for (let cursor = start.clone(); cursor.isBefore(end); cursor.add(slotInMinutes, 'minutes')) {
      const h = cursor.hour();
      const m = cursor.minute();
      const key = h + ':' + m;
      if (!seen[key]) {
        this.timingSlots.push({ hour: h, minute: m });
        seen[key] = true;
      }
    }
  }

  getActivitySlot(): any {
    if (!this.timingSlots.length) { return null; }
    const currentLocalTime = moment().utcOffset(this.timezoneOffset);
    const currentHour = currentLocalTime.hour();
    const currentMinutes = currentLocalTime.minutes();
    let slot = this.timingSlots[0];
    const slotFloat = parseFloat(currentHour + '.' + currentMinutes);
    for (let i = this.timingSlots.length - 1; i > 0; i--) {
      const _slot = this.timingSlots[i];
      const _slotFloat = parseFloat(_slot.hour + '.' + _slot.minute);
      if (slotFloat > _slotFloat) {
        slot = _slot;
        break;
      }
    }
    return slot;
  }

  enableIcon() {
    this.handleIcon();
    let attendees: any;
    let maxNoOfPeopleAllowed: any;
    const timeZoneSelectedDate = moment(this.bookingDate).utcOffset(this.timezoneOffset);
    if (this.selectedActivity && this.selectedActivity['isAttendeeCountRequired']) {
      if (this.bookingObj.attendees) {
        attendees = this.bookingObj.attendees;
        if (timeZoneSelectedDate.day() === 0 || timeZoneSelectedDate.day() === 6) {
          maxNoOfPeopleAllowed = this.selectedActivity['maxNumberOfPeopleWeekend'];
          if (attendees === maxNoOfPeopleAllowed) {
            this.disableIncreaseIcon = true;
            this.nocursorplus = 'no-cursor';
          }
        } else {
          maxNoOfPeopleAllowed = this.selectedActivity['maxNumberOfPeopleWeekday'];
        }
        if (attendees === maxNoOfPeopleAllowed) {
          this.disableIncreaseIcon = true;
          this.nocursorplus = 'no-cursor';
        }
      }
    }
  }

  prepopulateValues() {
    if (!this.selectedActivity || !this.selectedActivity.timings) { return; }

    const openTime = this.selectedActivity.timings.openTime.split(':');
    const facilityCloseTime = this.selectedActivity.timings.closeTime.split(':');

    const hour = parseInt(facilityCloseTime[0], 10);
    const minute = parseInt(facilityCloseTime[1], 10);
    const closeTime = new Date();
    closeTime.setHours(hour, minute, 0, 0);

    const _currentTime = moment().utcOffset(this.timezoneOffset, true).toISOString();
    const currentTime = new Date(_currentTime);
    currentTime.setSeconds(0, 0);

    const bookingDate = this.bookingDate;
    bookingDate.setSeconds(0, 0);

    if (this.bookingDate < closeTime) {
      if (currentTime.getTime() > closeTime.getTime()) {
        this.bookingObj.startTime_hours = ('0' + openTime[0]).slice(-2);
        this.bookingObj.startTime_minutes = ('0' + openTime[1]).slice(-2);
        this.bookingStartLockOn = this.bookingObj.startTime_hours + ':' + this.bookingObj.startTime_minutes;
        this.bookingObj.endTime = '';
      } else {
        const slot = this.getActivitySlot() || { hour: parseInt(openTime[0], 10), minute: parseInt(openTime[1], 10) };
        this.bookingObj.startTime_hours = ('0' + slot.hour).slice(-2);
        this.bookingObj.startTime_minutes = ('0' + slot.minute).slice(-2);
        this.bookingStartLockOn = this.bookingObj.startTime_hours + ':' + this.bookingObj.startTime_minutes;
        this.getEndTime();
      }
    } else {
      this.bookingObj.startTime_hours = ('0' + openTime[0]).slice(-2);
      this.bookingObj.startTime_minutes = ('0' + openTime[1]).slice(-2);
      this.bookingStartLockOn = this.bookingObj.startTime_hours + ':' + this.bookingObj.startTime_minutes;
      this.getEndTime();
    }
  }

  calculateCheckInTime(reqObj: any) {
    const currentDay = moment().utcOffset(this.timezoneOffset);
    const currentTime = currentDay.toISOString();
    if (currentDay.isBetween(moment(reqObj.startTime).utcOffset(this.timezoneOffset), moment(reqObj.endTime).utcOffset(this.timezoneOffset))) {
      return currentTime;
    } else {
      return '';
    }
  }

  setMinVal() {
    if (parseInt((this.bookingObj.attendees + '').trim(), 10) <= 0) {
      this.validate.attendees = 'required';
      this.disableDecreaseIcon = true;
    }
  }

  setMinValSlots() {
    if (parseInt((this.bookingObj.slots + '').trim(), 10) <= 1) {
      this.bookingObj.slots = '1';
      this.validate.slots = '';
      this.disableDecreaseIconOfSlots = true;
    } else {
      this.disableDecreaseIconOfSlots = false;
    }
  }

  handleIcon() {
    if (parseInt(this.bookingObj.attendees || '0', 10) <= 1) {
      this.disableDecreaseIcon = true;
      this.nocursor = 'no-cursor';
      this.nocursorplus = '';
      this.disableIncreaseIcon = false;
    } else if (parseInt(this.bookingObj.attendees || '0', 10) > 1 && this.checkAttendeeCount()) {
      this.disableDecreaseIcon = false;
      this.nocursor = '';
      this.nocursorplus = 'no-cursor';
      this.disableIncreaseIcon = true;
    } else {
      this.disableDecreaseIcon = false;
      this.nocursor = '';
      this.nocursorplus = '';
      this.disableIncreaseIcon = false;
    }
  }

  handleBookingIcons() {
    if (this.bookingObj.slots) {
      if (parseInt(this.bookingObj.slots, 10) === 1) {
        this.disableDecreaseIconOfSlots = true;
        this.noCursorSlots = 'no-cursor';
        this.disableIncreaseIconSlot = false;
        this.nocursorplusSlot = '';
      } else if (parseInt(this.bookingObj.slots, 10) > 1 && this.checkAttendeeCount()) {
        this.disableDecreaseIconOfSlots = false;
        this.noCursorSlots = '';
        this.disableIncreaseIconSlot = true;
        this.nocursorplusSlot = 'no-cursor';
      } else {
        this.disableDecreaseIconOfSlots = false;
        this.noCursorSlots = '';
        this.disableIncreaseIconSlot = false;
        this.nocursorplusSlot = '';
      }
    } else {
      if (parseInt(this.bookingObj.slots || '0', 10) === 0) {
        this.disableDecreaseIconOfSlots = true;
        this.noCursorSlots = 'no-cursor';
        this.disableIncreaseIconSlot = false;
        this.nocursorplusSlot = '';
      } else {
        this.disableDecreaseIconOfSlots = true;
        this.noCursorSlots = 'no-cursor';
        this.disableIncreaseIconSlot = true;
        this.nocursorplusSlot = 'no-cursor';
      }
    }
    this.validate.slots = this.bookingObj.slots ? '' : 'required';
  }

  showPreviousVal() {
    if (!this.selectedActivity || !this.selectedActivity.activitySlots) { return; }
    this.bookingStartLockOn = this.utilityFunctions.showPreviousVal(this.selectedActivity.activitySlots, this.bookingStartLockOn);
    this.blockPrev = this.bookingStartLockOn === this.selectedActivity.activitySlots[0] ? false : true;
    this.blockNext = this.bookingStartLockOn === this.selectedActivity.activitySlots[this.selectedActivity.activitySlots.length - 1] ? false : true;
    const startTime = this.bookingStartLockOn ? this.bookingStartLockOn.split(':') : [];
    this.bookingObj.startTime_hours = ('0' + startTime[0]);
    this.bookingObj.startTime_minutes = ('0' + startTime[1]);
    this.getEndTime();
  }

  showNextSlot() {
    if (!this.selectedActivity || !this.selectedActivity.activitySlots) { return; }
    this.bookingStartLockOn = this.utilityFunctions.showNextSlot(this.selectedActivity.activitySlots, this.bookingStartLockOn);
    this.blockPrev = this.bookingStartLockOn === this.selectedActivity.activitySlots[0] ? false : true;
    this.blockNext = this.bookingStartLockOn === this.selectedActivity.activitySlots[this.selectedActivity.activitySlots.length - 1] ? false : true;
    const startTime = this.bookingStartLockOn ? this.bookingStartLockOn.split(':') : [];
    this.bookingObj.startTime_hours = ('0' + startTime[0]);
    this.bookingObj.startTime_minutes = ('0' + startTime[1]);
    this.getEndTime();
  }

  calculateBookingSlot() {
    if (!this.selectedActivity || !this.selectedActivity.activitySlots || !this.selectedActivity.activitySlots.length) { return; }
    const slot = this.bookingObj.startTime_hours + ':' + this.bookingObj.startTime_minutes;
    let i = -1;
    do { i++; } while (this.selectedActivity.activitySlots[i] <= slot && i < this.selectedActivity.activitySlots.length);
    this.bookingStartLockOn = this.selectedActivity.activitySlots[i - 1] || this.selectedActivity.activitySlots[0];
    this.blockPrev = this.bookingStartLockOn === this.selectedActivity.activitySlots[0] ? false : true;
    this.blockNext = this.bookingStartLockOn === this.selectedActivity.activitySlots[this.selectedActivity.activitySlots.length - 1] ? false : true;
  }

  calculateEndTimeFromLockSlot() {
    if (!this.facility || !this.facility.activitySlots) { return; }
    this.blockPrev = this.bookingStartLockOn === this.facility.activitySlots[0] ? false : true;
    this.blockNext = this.bookingStartLockOn === this.facility.activitySlots[this.facility.activitySlots.length - 1] ? false : true;
    const startTime = this.bookingStartLockOn ? this.bookingStartLockOn.split(':') : [];
    this.bookingObj.startTime_hours = ('0' + startTime[0]);
    this.bookingObj.startTime_minutes = ('0' + startTime[1]);
    this.getEndTime();
  }

  /** Validation (Group Classes bypass most checks) */
  public checkAttendeeCount(): boolean {
    if (!this.selectedActivity || !this.selectedActivity['isAttendeeCountRequired']) {
      return false;
    }
    const attendeesStr = (this.bookingObj && this.bookingObj.attendees) ? String(this.bookingObj.attendees) : '0';
    const attendees = parseInt(attendeesStr, 10);
    if (!isFinite(attendees) || attendees <= 0) return true;

    const date = moment(this.bookingDate).utcOffset(this.timezoneOffset);
    const isWeekend = date.day() === 0 || date.day() === 6;

    const maxWeekend = this.selectedActivity['maxNumberOfPeopleWeekend'];
    const maxWeekday = this.selectedActivity['maxNumberOfPeopleWeekday'];

    let maxAllowed: number;
    if (isWeekend) {
      maxAllowed = (typeof maxWeekend === 'number' && isFinite(maxWeekend)) ? maxWeekend : Number.POSITIVE_INFINITY;
    } else {
      maxAllowed = (typeof maxWeekday === 'number' && isFinite(maxWeekday)) ? maxWeekday : Number.POSITIVE_INFINITY;
    }

    return attendees > maxAllowed;
  }

  validationForMandatoryFields(validatePara: string, event?: any, validateForSlots?: boolean) {
    try {
      if (this.isGroupClassCategory) { return true; }

      let validateFlag = true;
      if ((event && event.keyCode !== 9) || validateForSlots) {
        switch (validatePara) {
          case 'membershipId':
            if (!(this.bookingObj.membershipId + '').trim() || this.bookingObj.membershipId === ' ') {
              this.bookingObj.membershipId = '';
              this.validate.membershipId = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
              this.membershipIdErr = '';
              validateFlag = false;
            } else if (!this.utilityFunctions.validateMemberShipId(this.bookingObj.membershipId)) {
              this.membershipIdErr = CONSTANT_MESSAGES.MEMBERSHIP_ID_VALIDATION;
              this.validate.membershipId = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            } else {
              this.validate.membershipId = '';
              this.membershipIdErr = '';
            }
            break;

          case 'firstName':
            if (!(this.bookingObj.firstName + '').trim() || this.bookingObj.firstName === ' ') {
              this.validate.firstName = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
              validateFlag = false;
            } else {
              this.validate.firstName = '';
            }
            break;

          case 'attendees':
            if ((parseInt((this.bookingObj.attendees + '').trim(), 10) < 1) &&
              (((this.bookingObj.attendees + '').trim().indexOf('+') >= 0) || ((this.bookingObj.attendees + '').trim().indexOf('e') >= 0))) {
              this.validate.attendees = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
              validateFlag = false;
            } else if (this.checkAttendeeCount()) {
              this.validate.attendees = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
              validateFlag = false;
              this.showNoOfPeopleErrorMsg();
            } else {
              this.validate.attendees = '';
              this.disableIncreaseIcon = false;
              this.nocursorplus = '';
            }
            break;

          case 'hour':
            if (this.showHour) {
              const hrStr = (this.bookingObj.hours + '').trim();
              if (!hrStr || hrStr.indexOf('+') >= 0 || hrStr.indexOf('e') >= 0) {
                this.validate.hour = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                validateFlag = false;
                this.bookingObj.endTime = '';
              } else if (!parseInt(this.bookingObj.hours, 10)) {
                this.validate.hour = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                this.bookingObj.endTime = '';
                validateFlag = false;
              } else if (parseInt(this.bookingObj.hours, 10) <= 0) {
                this.validate.hour = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                this.bookingObj.endTime = '';
                validateFlag = false;
              } else {
                this.validate.hour = '';
                this.getEndTime();
              }
            }
            break;

          case 'startTime_hours':
            if (!(this.bookingObj.startTime_hours + '').trim() || this.bookingObj.startTime_hours === ' ') {
              this.validate.startTime_hours = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
              validateFlag = false;
            } else {
              this.validate.startTime_hours = '';
              this.getEndTime();
            }
            break;

          case 'startTime_minutes':
            if (!(this.bookingObj.startTime_minutes + '').trim() || this.bookingObj.startTime_minutes === ' ') {
              this.validate.startTime_minutes = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
              validateFlag = false;
            } else {
              this.validate.startTime_minutes = '';
              this.getEndTime();
            }
            break;

          case 'endTime':
            if (!(this.bookingObj.endTime + '').trim() || this.bookingObj.endTime === ' ') {
              this.validate.endTime = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
              validateFlag = false;
            } else {
              this.validate.endTime = '';
            }
            break;

          case 'emailId':
            if (this.bookingObj.emailId) {
              if (!this.utilityFunctions.validateEmail(this.bookingObj.emailId)) {
                this.validate.emailId = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                validateFlag = false;
              } else {
                this.validate.emailId = '';
              }
            }
            break;

          case 'countryCode':
            if (!(this.bookingObj.countryCode + '').trim()) {
              this.validate.countryCode = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
              validateFlag = false;
            } else {
              this.validate.countryCode = '';
            }
            break;

          case 'contactNumber':
            const regEx = /^\d{4,16}$/;
            if ((this.bookingObj.contactNumber + '').trim() && regEx.test(this.bookingObj.contactNumber)) {
              this.validate.contactNumber = '';
            } else {
              this.validate.contactNumber = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
              this.validate.flag = false;
            }
            break;

          case 'slot':
            if (this.bookingObj.slots) {
              this.getEndTime();
              this.validate.slots = '';
            } else {
              this.endTime = '';
              this.validate.slots = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
              validateFlag = false;
            }
            break;

          case '':
            validateFlag = this.validateMandatoryFields();
            break;

          case 'memberIdOrFirstName':
            if (!this.utilityFunctions.validateMemberShipId(this.memberIdOrFirstName)) {
              this.membershipIdErr = CONSTANT_MESSAGES.MEMBERSHIP_ID_VALIDATION;
              this.validate.memberIdOrFirstName = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
            } else {
              this.validate.memberIdOrFirstName = '';
              this.membershipIdErr = '';
            }
            break;

          case 'repeatCount':
            if (this.repeatCount) {
              const rcStr = (this.repeatCount + '').trim();
              if ((parseInt(rcStr, 10) < 1) && (rcStr.indexOf('+') >= 0 || rcStr.indexOf('e') >= 0)) {
                this.validate.repeatCount = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
                this.validate.flag = false;
              } else {
                this.validate.repeatCount = '';
              }
            } else {
              this.validate.repeatCount = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
              this.validate.flag = false;
            }
            break;
        }
      }
      return validateFlag;
    } catch (e) {
      console.log(e);
      return false;
    }
  }

  validateMandatoryFields() {
    if (this.isGroupClassCategory) {
      this.validate.flag = true;
      return true;
    }

    this.validate.flag = true;
    const regEx = /^\d{4,16}$/;

    if (!(this.bookingObj.membershipId + '').trim()) {
      this.validate.membershipId = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
      this.validate.flag = false;
    } else {
      this.validate.membershipId = '';
    }

    if (!(this.bookingObj.firstName + '').trim()) {
      this.validate.firstName = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
      this.validate.flag = false;
    } else {
      this.validate.firstName = '';
    }

    const attStr = (this.bookingObj.attendees + '').trim();
    if (!attStr && (attStr.indexOf('+') >= 0 || attStr.indexOf('e') >= 0)) {
      this.validate.attendees = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
      this.validate.flag = false;
    } else if (!parseInt(this.bookingObj.attendees, 10) || this.checkAttendeeCount()) {
      this.validate.attendees = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
      this.validate.flag = false;
      this.showNoOfPeopleErrorMsg();
    } else {
      this.validate.attendees = '';
      this.disableIncreaseIcon = false;
      this.nocursorplus = '';
    }

    if (!(this.bookingObj.startTime_hours + '').trim()) {
      this.validate.startTime_hours = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
      this.validate.flag = false;
    } else {
      this.validate.startTime_hours = '';
    }

    if (!(this.bookingObj.startTime_minutes + '').trim()) {
      this.validate.startTime_minutes = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
      this.validate.flag = false;
    } else {
      this.validate.startTime_minutes = '';
    }

    if (!(this.bookingObj.endTime + '').trim()) {
      this.validate.endTime = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
      this.validate.flag = false;
    } else {
      this.validate.endTime = '';
    }

    if (this.showAddMemberFields) {
      if (this.bookingObj.emailId) {
        if (!this.utilityFunctions.validateEmail(this.bookingObj.emailId)) {
          this.validate.emailId = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
          this.validate.flag = false;
        } else {
          this.validate.emailId = '';
        }
      } else {
        this.validate.emailId = '';
      }
    } else {
      this.validate.emailId = '';
    }

    if (this.showAddMemberFields) {
      if (!(this.bookingObj.countryCode + '').trim()) {
        this.validate.countryCode = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        this.validate.flag = false;
      } else {
        this.validate.countryCode = '';
      }
    } else {
      this.validate.countryCode = '';
    }

    if (this.showAddMemberFields) {
      if ((this.bookingObj.contactNumber + '').trim() && regEx.test(this.bookingObj.contactNumber)) {
        this.validate.contactNumber = '';
      } else {
        this.validate.contactNumber = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        this.validate.flag = false;
      }
    } else {
      this.validate.contactNumber = '';
    }

    if (parseInt(this.bookingObj.slots, 10) >= 1) {
      this.validate.slots = '';
    } else {
      this.validate.slots = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
      this.validate.flag = false;
    }

    if (!(this.memberIdOrFirstName + '').trim()) {
      this.validate.memberIdOrFirstName = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
      this.validate.flag = false;
    } else {
      this.validate.memberIdOrFirstName = '';
    }

    if (this.selectedActivity && this.selectedActivity.isWeeklyRepeatBooking) {
      if (this.repeatCount) {
        const rcStr = (this.repeatCount + '').trim();
        if ((parseInt(rcStr, 10) < 1) && (rcStr.indexOf('+') >= 0 || rcStr.indexOf('e') >= 0)) {
          this.validate.repeatCount = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
          this.validate.flag = false;
        } else {
          this.validate.repeatCount = '';
        }
      } else {
        this.validate.repeatCount = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        this.validate.flag = false;
      }
    }

    return this.validate.flag;
  }

  resetAll(isFromCancel: boolean) {
    this.bookingObj = {
      emailId: '',
      contactNumber: '',
      firstName: '',
      membershipId: '',
      userId: '',
      attendees: '1',
      hours: '',
      startTime_hours: '',
      startTime_minutes: '',
      startTime: '',
      endTime: '',
      type: '',
      lastName: '',
      isForcedBooking: false,
      countryCode: '',
      slots: '1',
      addressLine1: '',
      addressLine2: '',
      note: '',
      groupNames: '',
      groups: [],
      bookingVendorNote: ''
    };

    this.validate = {
      emailId: '',
      contactNumber: '',
      firstName: '',
      membershipId: '',
      attendees: '',
      hour: '',
      flag: false,
      startTime_hours: '',
      startTime_minutes: '',
      startTime: '',
      endTime: '',
      type: '',
      lastName: '',
      isForcedBooking: false,
      countryCode: '',
      slots: '',
      memberIdOrFirstName: '',
      repeatCount: ''
    };

    this.errMessage = '';
    this.isShowWithinBookingperiodErrorMsg = false;
    this.withinBookingperiodErrorMsg = '';

    const timeZoneDate = moment().utcOffset(this.timezoneOffset);
    this.endMinDate = new Date(timeZoneDate.year(), timeZoneDate.month(), timeZoneDate.date(), timeZoneDate.hour(), timeZoneDate.minutes());
    this.minDate = new Date(timeZoneDate.year(), timeZoneDate.month(), timeZoneDate.date(), timeZoneDate.hour(), timeZoneDate.minutes());

    this.bookingObj.attendees = '1';
    this.bookButtonText = CONSTANT_MESSAGES.BOOK_BUTTON_TEXT;
    this.isShowCanBeForceBookedMessage = false;
    this.ActivityStartTimeHoursList = [];
    this.bookingStartLockOn = '';
    this.memberAddedSuccesfullyMsg = '';
    this.isopen1 = false;
    this.repeatCount = (this.selectedActivity && this.selectedActivity.isWeeklyRepeatBooking) ? 1 : 0;
    this.continueBookingMessage = '';
    this.statusOFBookings = [];
    this.checkAvailability = (this.selectedActivity && this.selectedActivity.isWeeklyRepeatBooking) ? true : false;
    this.memberAddedMessage = '';
    this.isShowAvailabilityStatus = false;
    this.showAddMemberFields = false;
    this.isDayBookingError = false;
    this.statusOFBookings = [];
    this.memberList = [];
    this.allSlotsUnavailable = true;
    this.showBook = true;
    this.monthWiseBlock = [];
    this.requestForRepeat = undefined;

    if (isFromCancel) { this.hideChildModal(); }
  }

  /** compute end time from start + slots */
  getEndTime() {
    if (!this.selectedActivity || !this.selectedActivity.timings) { return; }

    if (this.isGroupClassCategory) {
      // Keep end time as per facility timings; just ensure validator passes
      this.validate.endTime = this.bookingObj.endTime ? '' : CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
      return;
    }

    this.alignStartToSlot();

    let tempActivityCloseTime: any;
    const bookingTime = moment(this.bookingDate).utcOffset(this.timezoneOffset);
    const date = bookingTime.date(), month = bookingTime.month(), year = bookingTime.year();

    const facilityCloseTime = this.selectedActivity.timings.closeTime.split(':');
    const hour = parseInt(facilityCloseTime[0], 10);
    const minute = parseInt(facilityCloseTime[1], 10);

    tempActivityCloseTime = moment(this.bookingDate).utcOffset(this.timezoneOffset);
    tempActivityCloseTime.set({ year, month, date, hours: hour, minute });

    const slotDuration = this.getSlotDuration();

    bookingTime.set({
      hour: parseInt(this.bookingObj.startTime_hours || '0', 10),
      minute: parseInt(this.bookingObj.startTime_minutes || '0', 10) + slotDuration * parseInt(this.bookingObj.slots || '1', 10)
    });

    if (bookingTime.minutes() === 0 && bookingTime.hours() === 0) {
      bookingTime.subtract(1, 'minutes');
    }

    if (bookingTime) {
      const bookingHours = bookingTime.hour() < 10 ? '0' + bookingTime.hour() : '' + bookingTime.hour();
      const bookingMinutes = bookingTime.minute() < 10 ? '0' + bookingTime.minute() : '' + bookingTime.minute();
      this.bookingObj.endTime = (bookingHours + ':' + bookingMinutes) === '23:59' ? '24:00' : (bookingHours + ':' + bookingMinutes);
    } else {
      this.bookingObj.endTime = '';
    }

    if (tempActivityCloseTime.isBefore(bookingTime)) {
      this.errMessage = CONSTANT_MESSAGES.BOOKING_WITHIN_ACTIVITY_TIMINGS_ERROR;
      this.endTime = '';
      this.bookingObj.endTime = '';
    } else {
      this.errMessage = '';
    }
    this.validate.endTime = this.bookingObj.endTime ? '' : CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
  }

  setDetails(userId: string) {
    if (userId) {
      const obj = _.find(this.memberList, { userId: userId });
      if (!obj) { this.validate.firstName = CONSTANT_VALUES.VALIDATOR_CLASS_NAME; this.bookingObj.firstName = ''; return; }
      this.bookingObj.firstName = obj.firstName;
      this.bookingObj.emailId = obj['emailId'];
      this.bookingObj.contactNumber = (obj['countryCode'] ? obj['countryCode'] : '').concat(' ' + obj['contactNumber']);
      this.bookingObj.userId = obj['userId'];
      this.bookingObj.membershipId = obj['membershipId'];

      if (!(this.bookingObj.firstName + '').trim()) {
        this.validate.firstName = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        this.validate.flag = false;
      } else {
        this.validate.firstName = '';
      }
    } else {
      this.validate.firstName = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
      this.bookingObj.firstName = '';
    }
  }

  getMemberList(membershipIdOrFirstName: string, popUpObj: any) {
    if (!(this.memberIdOrFirstName + '').trim() || !this.utilityFunctions.validateMemberShipId(this.memberIdOrFirstName)) {
      this.validate.membershipId = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
      this.validate.flag = false;
      this.resetFields();
    } else {
      this.validate.membershipId = '';
      this.getDataByMemberShipId(membershipIdOrFirstName, popUpObj);
    }
  }

  resetData() {
    this.bookingObj.contactNumber = '';
    this.bookingObj.emailId = '';
    this.bookingObj.firstName = '';
    this.bookingObj.type = '';
    this.bookingObj.lastName = '';
    this.bookingObj.membershipId = '';
    this.isEmailIdDisable = true;
    this.memberList = [];
    this.isDayBookingError = false;
    this.errMessage = '';
  }

  resetFields() {
    this.bookingObj.emailId = '';
    this.bookingObj.contactNumber = '';
    this.bookingObj.firstName = '';
    this.bookingObj.userId = '';
    this.bookingObj.type = '';
    this.bookingObj.lastName = '';
    this.bookingObj.membershipId = '';
    this.isEmailIdDisable = true;
    this.isDayBookingError = false;
    this.errMessage = '';
  }

  setBookingDate(bookingStartDate: Date) {
    this.selectedBookingDate = moment(bookingStartDate).utcOffset(this.timezoneOffset).set({ hour: 0, second: 0, minute: 0, millisecond: 0 });
    this.eventdate = this.selectedBookingDate.format('LL');

    if (this.isGroupClassCategory) {
      this.setGroupClassTimingsFromFacility();
      return;
    }

    this.prepopulateValues();
  }

  changeEndMinDate(startDate: Date) {
    this.endMinDate = startDate;
    this.getMaxDateIfMonthRule();
  }

  decreaseNoOfPeople(currentAttendees: string) {
    let curr = parseInt(currentAttendees, 10);
    if (curr !== 1) {
      curr--;
      this.bookingObj.attendees = curr.toString();
    }
    this.enableIcon();
  }

  increaseNoOfPeople(currentAttendees: string) {
    const timeZoneSelectedDate = moment(this.bookingDate).utcOffset(this.timezoneOffset);
    let maxNoOfPeopleAllowed: number;
    let attendees: number;

    if (this.selectedActivity && this.selectedActivity['isAttendeeCountRequired']) {
      attendees = parseInt(this.bookingObj.attendees || '0', 10) + 1;
      if (timeZoneSelectedDate.day() === 0 || timeZoneSelectedDate.day() === 6) {
        maxNoOfPeopleAllowed = this.selectedActivity['maxNumberOfPeopleWeekend'];
        if (attendees === maxNoOfPeopleAllowed) {
          this.disableIncreaseIcon = true;
          this.nocursorplus = 'no-cursor';
        }
      } else {
        maxNoOfPeopleAllowed = this.selectedActivity['maxNumberOfPeopleWeekday'];
        if (attendees === maxNoOfPeopleAllowed) {
          this.disableIncreaseIcon = true;
          this.nocursorplus = 'no-cursor';
        }
      }
      this.validate.attendees = '';
      if (parseInt(currentAttendees || '0', 10) < maxNoOfPeopleAllowed) {
        const next = parseInt(currentAttendees || '0', 10) + 1;
        this.bookingObj.attendees = next.toString();
      }
    } else {
      const next = parseInt(currentAttendees || '0', 10) + 1;
      this.bookingObj.attendees = next.toString();
    }

    this.validate.attendees = (this.bookingObj.attendees && parseInt(this.bookingObj.attendees, 10) > 0) ? '' : CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
    if (parseInt(this.bookingObj.attendees, 10) <= 1) {
      this.disableDecreaseIcon = true;
      this.nocursor = 'no-cursor';
    } else {
      this.disableDecreaseIcon = false;
      this.nocursor = '';
    }
  }

  showNoOfPeopleErrorMsg() {
    if (this.selectedActivity && this.selectedActivity['isAttendeeCountRequired']) {
      const timeZoneSelectedDate = moment(this.bookingDate).utcOffset(this.timezoneOffset);
      if (timeZoneSelectedDate.day() === 0 || timeZoneSelectedDate.day() === 6) {
        this.noOfPeopleErrorMsg = CONSTANT_MESSAGES.MAX_NO_OF_PEOPLE_ERROR + this.selectedActivity['maxNumberOfPeopleWeekend'];
        this.disableIncreaseIcon = true;
        this.nocursorplus = 'no-cursor';
      } else {
        this.noOfPeopleErrorMsg = CONSTANT_MESSAGES.MAX_NO_OF_PEOPLE_ERROR + this.selectedActivity['maxNumberOfPeopleWeekday'];
        this.disableIncreaseIcon = true;
        this.nocursorplus = 'no-cursor';
      }
    } else {
      this.noOfPeopleErrorMsg = '';
      this.disableIncreaseIcon = false;
      this.nocursorplus = '';
    }
  }

  decreaseNoOfSlots(currentSlots: string) {
    let curr = parseInt(currentSlots || '1', 10);
    if (curr > 1) {
      curr--;
      this.bookingObj.slots = curr.toString();
      if (this.bookingObj.startTime_hours || this.bookingObj.startTime_minutes) {
        this.getEndTime();
      }
    }
    this.handleBookingIcons();
  }

  increaseNoOfSlots(currentSlots: string) {
    let curr = parseInt(currentSlots || '1', 10);
    curr++;
    this.bookingObj.slots = curr.toString();
    if (this.bookingObj.startTime_hours || this.bookingObj.startTime_minutes) {
      this.getEndTime();
    }
    this.handleBookingIcons();
  }

  isInBreakTime(referenceDate: Date): boolean {
    const breakTimings = (this.selectedActivity && this.selectedActivity.breakTimings) || [];
    return breakTimings.some(function (_break: any) {
      const startHour = parseInt(_break.start.split(':')[0], 10);
      const startMinute = parseInt(_break.start.split(':')[1], 10);
      const endHour = parseInt(_break.end.split(':')[0], 10);
      const endMinute = parseInt(_break.end.split(':')[1], 10);

      const start = new Date();
      start.setHours(startHour, startMinute, 0, 0);
      const end = new Date();
      end.setHours(endHour, endMinute, 0, 0);

      return referenceDate.getTime() >= start.getTime() && referenceDate.getTime() <= end.getTime();
    });
  }

  showParentPopup() {
    this.showChildModal(this.bookingObj.membershipId);
  }

  getDataByMemberShipId(membershipId: string, popUpObj: any) {
    this.loaderEvent.fire(false);
    const requestObject: any = { membershipId: membershipId };

    if (this._appService.getVendorRole() === CONSTANT_VALUES.ROLE_VENDOR_ADMIN) {
      requestObject.vendorId = this.vendor ? this.vendor._id : '';
    } else {
      requestObject.vendorId = this.vendor ? this.vendor.vendorId : '';
    }

    this.calendarService.getMembersByMembershipId(requestObject).then((result: any) => {
      if (result.status === CONSTANT_VALUES.RESPONSE_SUCCESS) {
        this.resetFields();
        this.memberList = (result.vendorData && result.vendorData[0] && result.vendorData[0]['members']) ? result.vendorData[0]['members'] : [];
        this.showAddMemberMessage = false;
        this.showAddMemberFields = false;
        this.isContactDisable = true;
        this.isEmailIdDisable = true;
        this.isopen1 = this.memberList.length > 0 ? true : false;
      } else {
        if (result.message === 'No such record found.') {
          this.showAddMemberMessage = true;
        } else {
          this.hideChildModal();
          this.memberList = [];
          this.popUpMessage = result.message;
          popUpObj.showChildModal();
        }
      }
      if (this.memberList.length > 0) {
        this.isEmailIdDisable = false;
      } else {
        this.resetFields();
      }
      this.loaderEvent.fire(true);
      return (!this.isEmailIdDisable);
    });
  }

  /* Booking Request */
  bookingTimeValidation(e: any, popUpObj: any, msgPopUpObj: any, bookingLog?: any) {
    if (this.validateMandatoryFields()) {
      if (this.checkMaxNumberOfPeopleWeekend(popUpObj)) {
        if (this.selectedActivity &&
          this.selectedActivity['isAttendeeCountRequired'] &&
          this.selectedActivity['maxNumberOfPeopleWeekday'] &&
          this.selectedActivity['maxNumberOfPeopleWeekday'] < parseInt(this.bookingObj.attendees, 10)) {
          this.validate.attendees = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
          this.popUpMessage = CONSTANT_MESSAGES.NUMPER_OF_PEOPLE_ERROR;
          this.hideChildModal();
          popUpObj.showChildModal();
        } else {
          this.isShowCanBeForceBookedMessage = false;
          this.bookingRequest(popUpObj, msgPopUpObj, bookingLog);
        }
      }
    } else {
      this.allSlotsUnavailable = true;
    }
  }

  checkMaxNumberOfPeopleWeekend(popUpObj: any) {
    if (!this.selectedActivity || !this.startTime) { return true; }
    const startHour = parseInt(this.startTime.split(':')[0], 10);
    this.selectedBookingDate = moment(this.bookingDate).utcOffset(this.timezoneOffset, true)
      .set({ hour: startHour, second: 0, minute: 0, millisecond: 0 });

    if (this.selectedActivity['isAttendeeCountRequired'] &&
      (this.selectedBookingDate.days() === 6 || this.selectedBookingDate.days() === 0)) {
      if (this.selectedActivity['maxNumberOfPeopleWeekend'] &&
        (this.selectedActivity['maxNumberOfPeopleWeekend'] < parseInt(this.bookingObj.attendees, 10))) {
        this.validate.attendees = CONSTANT_VALUES.VALIDATOR_CLASS_NAME;
        this.popUpMessage = CONSTANT_MESSAGES.NUMPER_OF_PEOPLE_ERROR;
        this.hideChildModal();
        popUpObj.showChildModal();
        return false;
      } else {
        return true;
      }
    } else {
      return true;
    }
  }

  bookingRequest(popUpObj: any, msgPopUpObj: any, bookingLog: any) {
    this.loaderEvent.fire(false);

    const slots = this.buildSlotsForDay();
    if (!slots.length) {
      this.popUpMessage = 'No slots available for this day.';
      return;
    }
    if (!this.selectedActivity || !this.selectedActivity.timings) { this.loaderEvent.fire(true); return; }

    // snap start to grid
    this.alignStartToSlot();

    // derive start & end
    const slotMin = this.getSlotDuration();
    const base = moment(this.bookingDate || new Date()).utcOffset(this.timezoneOffset, true);

    const closeParts = (this.selectedActivity.timings.closeTime || '23:59').split(':');
    const closeH = parseInt(closeParts[0], 10) || 0;
    const closeM = parseInt(closeParts[1], 10) || 0;
    const dayEnd = (closeH === 24 && closeM === 0)
      ? base.clone().add(1, 'day').startOf('day')
      : base.clone().set({ hour: closeH, minute: closeM, second: 0, millisecond: 0 });

    const sh = parseInt(this.bookingObj.startTime_hours || '0', 10) || 0;
    const sm = parseInt(this.bookingObj.startTime_minutes || '0', 10) || 0;

    const start = base.clone().set({ hour: sh, minute: sm, second: 0, millisecond: 0 });
    const wantedSlots = Math.max(parseInt(this.bookingObj.slots || '1', 10) || 1, 1);
    const end = start.clone().add(slotMin * wantedSlots, 'minutes');

    if (end.isAfter(dayEnd) || !end.isAfter(start)) {
      this.popUpMessage = 'Booking timing should be equal to slot timing.';
      this.hideChildModal();
      popUpObj.showChildModal();
      this.loaderEvent.fire(true);
      return;
    }

    // reflect to UI
    const eh = ('0' + end.hour()).slice(-2);
    const em = ('0' + end.minute()).slice(-2);
    this.bookingObj.endTime = (eh + ':' + em) === '23:59' ? '24:00' : (eh + ':' + em);
    this.validate.endTime = '';

    if (!this.validateMandatoryFields()) { this.loaderEvent.fire(true); return; }

    // Prepare payload
    let memberData: any;
    if (this.bookingObj.groupNames) {
      this.bookingObj.groups = this.utilityFunctions.createGroupArray(this.bookingObj.groupNames);
    }

    if (this.showAddMemberFields && this.memberAddedSuccesfullyMsg === '') {
      memberData = {
        membershipId: this.bookingObj.membershipId,
        firstName: this.bookingObj.firstName,
        lastName: this.bookingObj.lastName,
        emailId: this.bookingObj.emailId,
        contactNumber: this.bookingObj.contactNumber,
        type: this.bookingObj.type,
        countryCode: this.bookingObj.countryCode,
        addressLine1: this.bookingObj.addressLine1,
        addressLine2: this.bookingObj.addressLine2,
        note: this.bookingObj.note,
        groups: this.bookingObj.groups
      };
    }

    if (this.bookButtonText === CONSTANT_MESSAGES.FORCEBOOK_BUTTON_TEXT) {
      this.bookingObj.isForcedBooking = true;
    }

    const vendorId = (this.appService.getVendorRole() === CONSTANT_VALUES.ROLE_VENDOR_ADMIN)
      ? (this.vendor ? this.vendor._id : '')
      : (this.vendor ? this.vendor.vendorId : '');

    const requestObject: any = {
      membershipId: this.bookingObj.membershipId,
      facilityId: this.selectedActivity ? this.selectedActivity._id : '',
      vendorId: vendorId,
      startTime: start.toISOString(),
      endTime: end.toISOString(),
      attendees: this.bookingObj.attendees,
      hours: this.bookingObj.hours,
      title: this.selectedActivity ? this.selectedActivity.name : '',
      unitName: (this.selectedActivity && this.selectedActivity.isCourtSelection) ? (this.unitName || this.selectedUnit || '') : '',
      isWalkInBooking: true,
      isForcedBooking: !!this.bookingObj.isForcedBooking,
      bookingSlots: this.bookingObj.slots,
      bookingNote: this.bookingObj.bookingVendorNote
    };

    const checkInTime = this.calculateCheckInTime(requestObject);
    if (checkInTime) { requestObject.checkInTime = checkInTime; }

    let actualReqObj: any;
    if (memberData && this.memberAddedSuccesfullyMsg === '') {
      actualReqObj = { vendorId: vendorId, bookingData: requestObject, memberData: memberData };
    } else {
      requestObject._id = (this.memberAddedSuccesfullyMsg !== '') ? this.userId : this.bookingObj.userId;
      if (this.selectedActivity && this.selectedActivity.isWeeklyRepeatBooking) {
        requestObject.userId = this.bookingObj.userId;
      }
      actualReqObj = requestObject;
    }

    this.bookingBasedOnMemberShipId(actualReqObj, popUpObj, msgPopUpObj, bookingLog);
  }

  testCategory() {
    if (!this.selectedActivity) { this.showHour = false; return; }
    if (_.indexOf(CONSTANT_VALUES.AMENITIES, this.selectedActivity.category) >= 0) {
      this.showHour = true;
    } else {
      this.showHour = false;
    }
  }

  populateAddMemberFields() {
    this.showAddMemberFields = true;
    this.isContactDisable = false;
    this.isEmailIdDisable = false;
    this.showAddMemberMessage = false;
    this.bookingObj.membershipId = this.memberIdOrFirstName;
  }

  getMemberListByIdOrName(membershipIdOrFirstName: string, popUpObj: any) {
    this.getMemberList(membershipIdOrFirstName, popUpObj);
  }

  bookingBasedOnMemberShipId(reqObject: any, popUpObj: any, msgPopUpObj: any, bookingLog: any) {
    if (reqObject.memberData && this.memberAddedSuccesfullyMsg === '') {
      this.addMemberWithBooking(reqObject, popUpObj, msgPopUpObj, bookingLog);
    } else {
      if (!this.selectedActivity || !this.selectedActivity.isWeeklyRepeatBooking) {
        this.bookingForMember(reqObject, msgPopUpObj);
      } else {
        const reqObjForRepeat: any = {
          repeatCount: this.repeatCount,
          isAvailabilityRequest: true,
          timezoneOffset: this.vendor ? this.vendor.timezoneOffset : 0,
          vendorId: (this.appService.getVendorRole() === CONSTANT_VALUES.ROLE_VENDOR_ADMIN)
            ? (this.vendor ? this.vendor._id : '')
            : (this.vendor ? this.vendor.vendorId : '')
        };
        reqObjForRepeat.repeatCount = this.repeatCount;
        reqObjForRepeat.bookingData = reqObject;
        this.repeatedBookingForMember(reqObjForRepeat, msgPopUpObj, bookingLog);
      }
    }
  }

  bookingForMember(reqObject: any, msgPopUpObj: any) {
    if (this.appService.getVendorRole() === CONSTANT_VALUES.ROLE_VENDOR_ADMIN) {
      reqObject.vendorId = this.vendor ? this.vendor._id : '';
    } else {
      reqObject.vendorId = this.vendor ? this.vendor.vendorId : '';
    }
    const userId = reqObject._id;

    this.calendarService.bookingForMember(reqObject).then((result: any) => {
      if (result.canBeForceBooked && this.isShowAllowForceBooking) {
        this.isShowCanBeForceBookedMessage = true;
        this.bookButtonText = CONSTANT_MESSAGES.FORCEBOOK_BUTTON_TEXT;
        this.loaderEvent.fire(true);
      } else {
        this.hideChildModal();
        this.resetAll(false);
        this.loaderEvent.fire(true);
        this.bookingPopupMessage = result.message;
        this.bookingConfirmation = result.status === 'SUCCESS';
        this.confirmationBookingResult = result.status === 'SUCCESS'
          ? this.generateInvoice(result.bookingData, userId, reqObject.bookingSlots)
          : undefined;
        msgPopUpObj.showChildModal();
      }
    });
  }

  addMemberWithBooking(reqObject: any, popupObj: any, msgPopUpObj: any, bookingLog: any) {
    if (this.appService.getVendorRole() === CONSTANT_VALUES.ROLE_VENDOR_ADMIN) {
      reqObject.vendorId = this.vendor ? this.vendor._id : '';
    } else {
      reqObject.vendorId = this.vendor ? this.vendor.vendorId : '';
    }
    if (!this.selectedActivity || !this.selectedActivity.isWeeklyRepeatBooking) {
      reqObject.repeatCount = 1;
    } else {
      reqObject.isAvailabilityRequest = true;
      reqObject.repeatCount = this.repeatCount;
    }
    reqObject.timezoneOffset = this.vendor ? this.vendor.timezoneOffset : 0;

    this.loaderEvent.fire(false);
    this.requestForRepeat = reqObject;

    this.calendarService.addMemberWithBooking(reqObject).then((result: any) => {
      if (this.showApiFailureIfAny(result)) {
    this.loaderEvent.fire(true);
    return;
  }
      if (!this.selectedActivity || !this.selectedActivity.isWeeklyRepeatBooking) {
        if (result.canBeForceBooked && this.isShowAllowForceBooking) {
          this.isShowCanBeForceBookedMessage = true;
          this.bookButtonText = CONSTANT_MESSAGES.FORCEBOOK_BUTTON_TEXT;
          this.userId = result.userId;
          this.loaderEvent.fire(true);
          this.memberAddedSuccesfullyMsg = result.memberMessage ? result.memberMessage : '';
        } else if (result.status === CONSTANT_VALUES.RESPONSE_ERROR) {
          this.popUpMessage = result.message;
          this.loaderEvent.fire(true);
          this.hideChildModal();
          popupObj.showChildModal();
        } else {
          if (result.data && result.data[0] && result.data[0].isFailed) {
            this.bookingPopupMessage = result.message ? result.message : result.memberMessage + result.data[0].bookingMessage;
            this.bookingConfirmation = false;
          } else {
            this.bookingPopupMessage = result.message ? result.message : (result.memberMessage + (result.data && result.data.bookingLogs && result.data.bookingLogs[0] ? result.data.bookingLogs[0].bookingMessage : ''));
            this.confirmationBookingResult = result.status === 'SUCCESS'
              ? this.generateInvoice(result.data.bookingLogs[0].jsonData, result.data.bookingLogs[0].userData._id, reqObject.bookingSlots)
              : undefined;
            this.bookingConfirmation = true;
          }
          this.hideChildModal();
          this.resetAll(false);
          this.loaderEvent.fire(true);
          msgPopUpObj.showChildModal();
        }
      } else {
        this.memberAddedSuccesfullyMsg = result.message;
        if (result.status === 'ERROR') {
          this.loaderEvent.fire(true);
        } else {
          this.memberAddedSuccesfullyMsg = result.memberMessage;
          if (this.requestForRepeat) {
            delete this.requestForRepeat.memberData;
            this.requestForRepeat.bookingData.userId = result.userId;
            this.requestForRepeat.bookingData._id = result.userId;
          }
          this.bookingObj.userId = result.userId;
          this.showAvailableSlots(result, popupObj, bookingLog);
        }
      }
    });
  }

  callRefreshPage(e: any) {
    this.hideChildModal();
    this.callRefreshList.emit(true);
  }

  callRefreshPageAfterInvoice() {
    this.bookingConfirmation = false;
    this.callRefreshList.emit(true);
  }

  repeatedBookingForMember(reqObject: any, popUpObj: any, bookingLog: any) {
    if (!reqObject || !reqObject.bookingData) { return; }
    reqObject.bookingData.isForcedBooking = false;
    this.requestForRepeat = reqObject;
    this.statusChecked = true;
    this.sendBookingToServer(reqObject, popUpObj, bookingLog);
  }

  /** Ensure requestForRepeat exists from current UI state (used before repeat). */
  private ensureRepeatRequest(): void {
    if (this.requestForRepeat) { return; }

    const openTimeHour = parseInt(this.bookingObj.startTime_hours || '0', 10);
    const openTimeMinutes = parseInt(this.bookingObj.startTime_minutes || '0', 10);
    const endParts = (this.bookingObj.endTime || '00:00').split(':');
    let closeTimeHours = parseInt(endParts[0] || '0', 10);
    let closeTimeMinutes = parseInt(endParts[1] || '0', 10);
    if (closeTimeHours === 24 && closeTimeMinutes === 0) {
      closeTimeHours = 23;
      closeTimeMinutes = 59;
    }

    const vendorId = (this.appService.getVendorRole() === CONSTANT_VALUES.ROLE_VENDOR_ADMIN)
      ? (this.vendor ? this.vendor._id : '')
      : (this.vendor ? this.vendor.vendorId : '');

    const startTimeIso = moment(this.bookingDate)
      .utcOffset(this.timezoneOffset, true)
      .set({ hour: openTimeHour, minute: openTimeMinutes, second: 0, millisecond: 0 })
      .toISOString();

    const endTimeIso = moment(this.bookingDate)
      .utcOffset(this.timezoneOffset, true)
      .set({ hour: closeTimeHours, minute: closeTimeMinutes, second: 0, millisecond: 0 })
      .toISOString();

    this.requestForRepeat = {
      repeatCount: this.repeatCount || 1,
      isAvailabilityRequest: false,
      timezoneOffset: (this.vendor && typeof this.vendor.timezoneOffset !== 'undefined') ? this.vendor.timezoneOffset : 0,
      vendorId: vendorId,
      bookingData: {
        membershipId: this.bookingObj.membershipId,
        facilityId: (this.selectedActivity && this.selectedActivity._id) ? this.selectedActivity._id : '',
        vendorId: vendorId,
        startTime: startTimeIso,
        endTime: endTimeIso,
        attendees: this.bookingObj.attendees,
        hours: this.bookingObj.hours,
        title: (this.selectedActivity && this.selectedActivity.name) ? this.selectedActivity.name : '',
        unitName: (this.selectedActivity && this.selectedActivity.isCourtSelection)
          ? (this.unitName || this.selectedUnit || '')
          : '',
        isWalkInBooking: true,
        isForcedBooking: false,
        bookingSlots: this.bookingObj.slots,
        bookingNote: this.bookingObj.bookingVendorNote,
        userId: this.bookingObj.userId,
        _id: this.bookingObj.userId
      }
    };
  }

  repeatBookingOnContinue(popUpObj: any, msgPopUpObj: any, bookingLog: any) {
    this.statusChecked = false;
    this.loaderEvent.fire(false);

    this.ensureRepeatRequest();

    this.requestForRepeat.isAvailabilityRequest = false;
    if (this.isShowAllowForceBooking && this.isShowCanBeForceBookedMessage) {
      this.requestForRepeat.bookingData.isForcedBooking = true;
    } else {
      this.requestForRepeat.bookingData.isForcedBooking = false;
    }

    this.calendarService.repeatedBookingForMember(this.requestForRepeat).then((result: any) => {
      if (this.showApiFailureIfAny(result)) {
    this.loaderEvent.fire(true);
    return;
  }

      this.resetAll(false);
      if (
        this.requestForRepeat &&
        this.requestForRepeat.repeatCount === 1 &&
        result &&
        result.data &&
        result.data.bookingLogs &&
        result.data.bookingLogs.length > 0
      ) {
        this.confirmationBookingResult = result.status === 'SUCCESS'
          ? this.generateInvoice(
            result.data.bookingLogs[0].jsonData,
            result.data.bookingLogs[0].userData._id,
            this.requestForRepeat.bookingData.bookingSlots
          )
          : undefined;
      }

      this.showAvailableSlots(result, msgPopUpObj, bookingLog, true);
      this.hideChildModal();
      if (bookingLog && bookingLog.showChildModal) {
        bookingLog.showChildModal(this.statusOFBookings, this.timezoneOffset);
      }
      this.resetAll(false);
      this.loaderEvent.fire(true);
      this.hideChildModal();
    });
  }

  repeatBookingAfterStatus(popUpObj: any, msgPopUpObj: any) {
    if (this.requestForRepeat) {
      this.requestForRepeat.isAvailabilityRequest = false;
      if (this.isShowAllowForceBooking && this.isShowCanBeForceBookedMessage) {
        this.requestForRepeat.bookingData.isForcedBooking = true;
      }
    }
  }

  sendBookingToServer(reqObject: any, msgPopUpObj: any, bookingLog: any) {
    if (reqObject) {
      this.loaderEvent.fire(false);
      this.calendarService.repeatedBookingForMember(reqObject).then((result: any) => {
        this.showAvailableSlots(result, msgPopUpObj, bookingLog);
      });
    } else {
      console.log('request object is not ready');
    }
  }

  handleRepeatBookingResponse(result: any, popUpObj: any) { /* kept minimal */ }

  showAvailableSlots(result: any, msgPopup: any, bookingLog: any, setForceFlag?: boolean) {
    this.ensureRepeatRequest();

    const flag = !!setForceFlag;
    this.allSlotsUnavailable = true;

    this.monthWiseBlock = [];
    const monthWiseBlock: any = {};
    this.statusOFBookings = [];

    if (!result || !result.data || !result.data.bookingLogs) {
      this.loaderEvent.fire(true);
      return;
    }

    result.data.bookingLogs.forEach((r: any) => {
      if (r.canBeForceBooked && this.isShowAllowForceBooking) {
        this.isShowCanBeForceBookedMessage = true;
        this.bookButtonText = CONSTANT_MESSAGES.FORCEBOOK_BUTTON_TEXT;
        if (this.requestForRepeat && this.requestForRepeat.bookingData) {
          this.requestForRepeat.bookingData.isForcedBooking = flag ? true : false;
        }
      } else {
        if (this.requestForRepeat && this.requestForRepeat.bookingData) {
          this.requestForRepeat.bookingData.isForcedBooking = false;
        }
      }

      const dateStr = moment(r.startTime).utcOffset(this.timezoneOffset).format('LL');
      const startTime = moment(r.startTime).utcOffset(this.timezoneOffset).format('LT');
      const endTime = moment(r.endTime).utcOffset(this.timezoneOffset).format('LT');
      const month = moment(r.startTime).utcOffset(this.timezoneOffset).format('MMMM YYYY');

      let showFlag = '';
      if (this.selectedActivity && this.selectedActivity.isAllowForceBooking) {
        showFlag = r.canBeForceBooked ? 'orange' : (r.isSucceeded ? 'green' : 'red');
      } else {
        showFlag = r.isSucceeded ? 'green' : 'red';
      }

      if (monthWiseBlock[month]) {
        monthWiseBlock[month].push({
          date: moment(r.startTime).utcOffset(this.timezoneOffset).dates(),
          status: !!r.isSucceeded,
          canBeForceBooked: !!r.canBeForceBooked,
          showFlag: showFlag
        });
      } else {
        monthWiseBlock[month] = [{
          date: moment(r.startTime).utcOffset(this.timezoneOffset).dates(),
          status: !!r.isSucceeded,
          canBeForceBooked: !!r.canBeForceBooked,
          showFlag: showFlag
        }];
      }

      const unitName = r.unitName ? r.unitName : undefined;
      const obj = {
        startTime: startTime,
        endTime: endTime,
        unitName: unitName,
        status: !!r.isSucceeded,
        date: dateStr,
        canBeForceBooked: !!r.canBeForceBooked
      };
      this.statusOFBookings.push(obj);
    });

    if (_.find(this.statusOFBookings, { status: true })) {
      this.allSlotsUnavailable = false;
    } else {
      if (_.find(this.statusOFBookings, { canBeForceBooked: true }) && this.selectedActivity && this.selectedActivity.isAllowForceBooking) {
        this.allSlotsUnavailable = false;
      } else {
        this.allSlotsUnavailable = true;
      }
    }

    if (_.find(this.statusOFBookings, { canBeForceBooked: true }) && this.selectedActivity && this.selectedActivity.isAllowForceBooking) {
      this.isShowCanBeForceBookedMessage = true;
    } else {
      this.isShowCanBeForceBookedMessage = false;
    }

    for (const key in monthWiseBlock) {
      if (Object.prototype.hasOwnProperty.call(monthWiseBlock, key)) {
        this.monthWiseBlock.push({ month: key, dates: monthWiseBlock[key] });
      }
    }

    this.loaderEvent.fire(true);
  }

  showInvoice(viewInvoice: any) {
    this.utilityFunctions.showInvoice(viewInvoice, this.confirmationBookingResult);
  }

  generateInvoice(bookingData: any, userId: string, bookingSlots: any) {
    this.loaderEvent.fire(false);
    const invoice: Invoice = {
      userId: userId,
      bookingId: bookingData.bookingId,
      facilityId: bookingData.facilityId,
      unitName: bookingData.unitName,
      activityCharges: this.selectedActivity ? this.selectedActivity.amount.value : 0,
      serviceId: (this.appService.getVendorRole() === CONSTANT_VALUES.ROLE_VENDOR_ADMIN)
        ? (this.vendor ? this.vendor._id : '')
        : (this.vendor ? this.vendor.vendorId : ''),
      isGSTApplicable: this.selectedActivity ? this.selectedActivity.isGSTApplicable : false,
      GSTValue: this.selectedActivity ? this.selectedActivity.GSTValue : 0,
      noOfPeople: bookingData.attendees,
      noOfSlotsBooked: '',
      facilityTimezoneOffset: this.selectedActivity ? this.selectedActivity.timezoneOffset : 0,
      timezoneAbbr: this.selectedActivity ? this.selectedActivity.timezoneAbbr : '',
      activityName: this.selectedActivity ? this.selectedActivity.name : '',
      bookingSlots: bookingSlots,
      currency: (this.selectedActivity && this.selectedActivity.amount) ? this.selectedActivity.amount.currency : ''
    };
    this.calendarService.generateInvoice(invoice).then((result: any) => {
      this.confirmationBookingResult = result.data || {};
      this.confirmationBookingResult.bookingId = bookingData.bookingId;
      this.confirmationBookingResult.userId = userId;
      this.confirmationBookingResult.vendorId = (this.appService.getVendorRole() === CONSTANT_VALUES.ROLE_VENDOR_ADMIN)
        ? (this.vendor ? this.vendor._id : '')
        : (this.vendor ? this.vendor.vendorId : '');
      this.loaderEvent.fire(true);
      if (result.status === 'SUCCESS') {
        return result.invoice;
      } else {
        return undefined;
      }
    });
  }

  showpaymentpopup(pymentDonePopup: any, message: string) {
    this.paymentDoneMessage = message;
    if (pymentDonePopup && pymentDonePopup.showChildModal) {
      pymentDonePopup.showChildModal();
    }
  }
  /** If API returns an array with {isFailed:true}, show its message in the error modal.
 *  Returns true if a failure was shown (caller should then stop further handling). */
private showApiFailureIfAny(result: any): boolean {
  // Normalize to an array safely (no optional chaining)
  var data = result && result.data;
  var arr: any[] = Array.isArray(data)
    ? data
    : (Array.isArray(result) ? result : []);

  // Find a failed entry
  var failed = arr && arr.find(function (x: any) {
    return x && (x.isFailed === true || x.status === 'FAILED');
  });

  if (failed) {
    this.errorMessage = failed.bookingMessage || failed.message || 'Booking failed.';
    this.hideChildModal();
    if (this.errorPopUpObj && this.errorPopUpObj.showChildModal) {
      this.errorPopUpObj.showChildModal();
    }
    return true;
  }
  return false;
}

}



// WEBPACK FOOTER //
// ./src/app/primecalendar/walkin-booking/walkin-booking.component.ts